import { isStringDefined } from '../../../utils/isDefined';
import Optional from '../../../utils/optional';
import { findSkuTranslation } from './customSearchActions';

const filterSubs = ({ subscriptions, filters, lang, selectedAccount }) => {
  let subs = subscriptions;
  if (isStringDefined(filters.search)) {
    subs = subs.filter(
      sub =>
        sub.name.toLowerCase().includes(filters.search.toLowerCase()) ||
        sub.status.toLowerCase().includes(filters.search.toLowerCase()) ||
        Optional(sub.user)
          .map(user =>
            user.toLowerCase().includes(filters.search.toLowerCase())
          )
          .or(false) ||
        Optional(sub.accountName)
          .map(name =>
            name.toLowerCase().includes(filters.search.toLowerCase())
          )
          .or(false) ||
        sub.quantity
          .toString()
          .toLowerCase()
          .includes(filters.search.toLowerCase()) ||
        findSkuTranslation({ rowData: sub, lang })
          .toLowerCase()
          .includes(filters.search.toLowerCase())
    );
  }
  if (filters.status.length > 0) {
    subs = subs.filter(sub =>
      filters.status.some(status => status.value === sub.status)
    );
  }

  if (selectedAccount?.type === 'CUSTOMER' && filters.account.length > 0) {
    subs = subs.filter(sub =>
      filters.account.some(
        account => account.accountNo === sub.account?.accountNo
      )
    );
  }

  if (filters.billingStatus.length > 0) {
    subs = subs.filter(sub =>
      filters.billingStatus.some(status => status.value === sub.billingStatus)
    );
  }

  if (filters.product.length > 0) {
    subs = subs.filter(sub =>
      filters.product.some(
        category =>
          category.value === findSkuTranslation({ rowData: sub, lang })
      )
    );
  }

  return subs;
};

export default filterSubs;
